function _is(i, n) {
  return typeof i === n;
}

function is() {
  if (1 === arguments.length) {
    const i = arguments;
    return function fn(n) {
      return _is(n, i[0]);
    };
  }
  return _is(arguments[0], arguments[1]);
}

function isString(i) {
  return "string" == typeof i;
}

function isNumber(i) {
  if ("number" == typeof i) {
    return !Number.isNaN(i);
  } else {
    return !1;
  }
}

function isBoolean(i) {
  return "boolean" == typeof i;
}

var isPromise = i => i instanceof Promise;

function isArray(i) {
  return Array.isArray(i);
}

function isObject(i) {
  if (i && !Array.isArray(i)) {
    return "object" == typeof i;
  } else {
    return !1;
  }
}

function isFunction(i) {
  return "function" == typeof i;
}

var isError = i => i instanceof Error;

var isDate = i => i instanceof Date;

function isNullable(i) {
  return null == i;
}

function isNotNullable(i) {
  return !(null == i);
}

var isNull = i => null === i;

var isUndefined = i => void 0 === i;

function _isNot(i, n) {
  return !n(i);
}

function isNot() {
  if (1 === arguments.length) {
    const i = arguments;
    return function fn(n) {
      return _isNot(n, i[0]);
    };
  }
  return _isNot(arguments[0], arguments[1]);
}

var i = {
  __proto__: null,
  is,
  isString,
  isNumber,
  isBoolean,
  isPromise,
  isArray,
  isObject,
  isFunction,
  isError,
  isDate,
  isNullable,
  isNotNullable,
  isNull,
  isUndefined,
  isNot
};

export { is as a, isString as b, isNumber as c, isBoolean as d, isPromise as e, isArray as f, isObject as g, isFunction as h, i, isError as j, isDate as k, isNullable as l, isNotNullable as m, isNull as n, isUndefined as o, isNot as p };
